import { makeStyles } from "@material-ui/styles";

export const useCreditCustomerStyles: any = makeStyles(
  (theme: { [key: string]: any }) => ({
    table: {
      minWidth: 935,
    },
    peopleIconMargin: {
      marginRight: theme.spacing(1),
       backgroundColor: "white",//"#8bc34a",
      boxShadow: "none",
      borderRadius: "3em",
    },
    peopleIcon: {
      width: ".90em",
      height: ".90em",
      color:"#233298 !important",
    },
    closeButton: {
      position: "absolute",
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    customerListTitle: {
      fontWeight: "bold",
      fontSize: "1.7em",
    },
    tableMessageStyle: {
      color: "black",
      fontWeight: "bold",
      fontSize: "1.3em",
      align:"right",
      paddingLeft:"3em"
    },
    SearchInput: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    searchPaper: {
      padding: "2px 4px",
      display: "flex",
      alignItems: "center",
      width: 400,
    },
  })
);
